import React, { useState, useEffect } from "react";
import { useRecoilValue } from "recoil";
import AssetItem from "./AssetItem";
import { configState } from "../../context/configState";
import ReactModal from "react-modal";
import AssetWithdraw from "./AssetWithdraw";
import AssetDeposit from "./AssetDeposit";
import { useToken } from "../../hooks/useToken";
import "../common/modal/modal.css";
import "./assets.css";
import "../common/input/input.css";
import { favourites } from "../../context/Favourites";
import FavouriteCoin from "../common/input/FavouriteCoin";
import AssetWrap from "./AssetWrap";
import AssetUnwrap from "./AssetUnwrap";

const AssetList = ({
  searchtext,
  mode,
  sortoption,
  sortOrder,
  balanceMap,
  handleRefetch,
}: {
  searchtext: any;
  mode: any;
  sortoption: any;
  sortOrder: any;
  balanceMap: any;
  handleRefetch: any;
}) => {
  const { getBalance } = useToken();
  const { assetsMap } = useRecoilValue(configState);
  let assets = Object.keys(assetsMap);
  const fav = useRecoilValue<any>(favourites);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const [isModalOpen4, setIsModalOpen4] = useState(false);
  const [activeToken, setActiveToken] = useState<any>();
  const [checkRefresh, setcheckRefresh] = useState(false);
  const scrtLogo = assetsMap["sSCRT"].logo_URIs.png;

  const sortedData = (tableData: any, reverse: boolean) => {
    assets.forEach((asset) => {
      if (balanceMap[asset] === undefined) {
        balanceMap[asset] = -1;
      }
    });
    const sorted = tableData.sort((asset1: any, asset2: any) =>
      assetsMap[asset1] !== null && assetsMap[asset2] !== null
        ? (
            sortoption === "asset_name"
              ? assetsMap[asset1]?.display_denom.toLowerCase() >
                assetsMap[asset2]?.display_denom.toLowerCase()
              : Number(balanceMap[asset1]) > Number(balanceMap[asset2])
          )
          ? 1
          : -1
        : -1
    );
    if (reverse) {
      return sorted.reverse();
    }
    return sorted;
  };

  return (
    <tbody className="all-pool-table-data">
      {(mode === "All"
        ? sortedData(assets, sortOrder === "desc")
        : sortedData(fav, sortOrder === "desc")
      )
        .filter((val: any) => {
          if (assetsMap[val] === undefined || assetsMap[val] === null)
            return null;
          if (searchtext === "") {
            return val;
          } else if (
            assetsMap[val].display_denom
              .toLowerCase()
              .includes(searchtext.toLowerCase()) ||
            assetsMap[val].name.toLowerCase().includes(searchtext.toLowerCase())
          ) {
            return val;
          }
        })
        .map((asset: any) => {
          if (assetsMap[asset] === undefined || assetsMap[asset] === null)
            return null;
          return (
            <tr key={asset} className="asset-item-container">
              <td className="asset-fav-icon" style={{ height: "5rem" }}>
                <FavouriteCoin coin={asset} />
              </td>
              <AssetItem
                onDeposit={() => {
                  setIsModalOpen(true);
                  setActiveToken(assetsMap[asset]);
                }}
                onWithdraw={() => {
                  setIsModalOpen2(true);
                  setActiveToken(assetsMap[asset]);
                }}
                onWrap={() => {
                  setIsModalOpen3(true);
                  setActiveToken(assetsMap[asset]);
                }}
                onUnWrap={() => {
                  setIsModalOpen4(true);
                  setActiveToken(assetsMap[asset]);
                }}
                props={{
                  coinName: assetsMap[asset]?.name,
                  displayDenom: assetsMap[asset]?.display_denom,
                  logoUrl: assetsMap[asset]?.logo_URIs.png,
                  onClick: () => {},
                  showName: true,
                }}
                displayTag={
                  assetsMap[asset]?.display_denom === "SCRT"
                    ? "NATIVE"
                    : assetsMap[asset]?.ibc
                    ? "IBC"
                    : "SNIP25"
                }
                isModalOpencheck={checkRefresh}
              />
            </tr>
          );
        })}
      <ReactModal
        isOpen={isModalOpen}
        className="custom-modal"
        onRequestClose={() => setIsModalOpen(false)}
      >
        <AssetDeposit
          setIsModalOpen={setIsModalOpen}
          assetToken={activeToken}
          scrtLogo={scrtLogo}
        />
      </ReactModal>
      <ReactModal
        isOpen={isModalOpen2}
        className="custom-modal"
        onRequestClose={() => setIsModalOpen2(false)}
      >
        <AssetWithdraw
          setIsModalOpen={setIsModalOpen2}
          assetToken={activeToken}
          scrtLogo={scrtLogo}
        />
      </ReactModal>

      <ReactModal
        isOpen={isModalOpen3}
        className="custom-modal"
        onRequestClose={() => setIsModalOpen3(false)}
      >
        <AssetWrap
          setIsModalOpen={setIsModalOpen3}
          assetToken={activeToken}
          scrtLogo={scrtLogo}
          setcheckRefresh = {setcheckRefresh}
        />
      </ReactModal>
      <ReactModal
        isOpen={isModalOpen4}
        className="custom-modal"
        onRequestClose={() => setIsModalOpen4(false)}
      >
        <AssetUnwrap
          setIsModalOpen={setIsModalOpen4}
          assetToken={activeToken}
          scrtLogo={scrtLogo}
          setcheckRefresh = {setcheckRefresh}
        />
      </ReactModal>
    </tbody>
  );
};

export default AssetList;
